<div>
<table class="path-point-parameters-table" [ngClass]="tableClasses">
    <thead>
    <tr>
        <th *ngIf="scoutPaths?.length>1">Path ID</th>
        <th *ngFor="let columnName of columnNames;" >{{columnName}}</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let scoutPath of scoutPaths;">        
    <tr *ngFor="let scoutPoint of scoutPath?.scoutPoints;" [ngClass]="{'bg-warning': scoutPoint.disabled}">
        <td *ngIf="scoutPaths.length>1" (click)="showScoutPath(scoutPath)" [attr.role]="detailFn?'button':''">
            <ng-container *ngIf="scoutPath.pathNumber">
                {{scoutTask.buildingId}}P{{scoutPath.pathNumber| number:'2.0'}}
            </ng-container>
        </td>
        <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.parentName}}</td>
        <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.name}}</td>

        <ng-container *ngIf="scoutPoint.type=='VIA'; else notViaCells">
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">VIA</td>
            <td></td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.latitude| number:'1.6-6'}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button" style="white-space: nowrap;">{{scoutPoint.longitude| number:'1.6-6'}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.altitudeEllipsoidMeters|number:'1.3-3'}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.horizontalError.cumulativeEstimate|number:'1.3-3'}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.verticalError.segmentEstimate|number:'1.3-3'}}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </ng-container>

        <ng-template #notViaCells>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">
                <ng-container [ngSwitch]="scoutPoint.type">
                    <ng-container *ngSwitchCase="'HA'">
                        {{scoutPoint.pointId || scoutPoint.exPointId || 'HA'}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'EX'">
                        {{scoutPoint.exPointId || 'EX'}}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        -
                    </ng-container>
                </ng-container>
            </td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.envData?.bInterior ? 'Interior' : (scoutPoint.envData?.bInterior === false ? 'Exterior' : '')}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.latitude| number:'1.6-6'}}</td>
            <td  (click)="showScoutPoint(scoutPath,scoutPoint)" role="button" style="white-space: nowrap;">{{scoutPoint.longitude| number:'1.6-6'}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.altitudeEllipsoidMeters|number:'1.3-3'}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.horizontalError.cumulativeEstimate|number:'1.3-3'}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.verticalError.segmentEstimate|number:'1.3-3'}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.envData?.nearestWindowDistance}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.envData?.windowCount}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.refData?.location1Distance}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.refData?.location2Distance}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.envData?.floorToCeilingHeight}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button">{{scoutPoint.envData?.quadrant}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button" style="min-width:8%;text-align:left;">{{scoutPoint.envData?.clutterDescription}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button" style="min-width:8%;text-align:left;">{{scoutPoint.envData?.hvacDescription}}</td>
            <td (click)="showScoutPoint(scoutPath,scoutPoint)" role="button" style="min-width:15%;text-align:left;">{{scoutPoint.envData?.pointDescription}}</td>
        </ng-template>
    </tr>
    </ng-container>
    </tbody>
</table>
</div>